var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944 4940 c-224 -59 -387 -223 -445 -448 -18 -73 -19 -125 -19 -1612 0 -1487 1 -1539 19 -1612 46 -180 160 -321 324 -405 63 -31 187 -63 249 -63 l48 0 0 -48 c0 -64 32 -187 66 -254 80 -159 225 -273 402 -319 72 -18 121 -19 1286 -19 1349 0 1285 -3 1432 70 141 69 257 207 307 365 l22 70 0 1575 0 1575 -22 70 c-50 158 -166 296 -307 365 -83 41 -189 70 -262 70 l-41 0 -6 73 c-18 214 -146 406 -331 497 -147 73 -82 70 -1436 69 -1154 0 -1219 -1 -1286 -19z m2536 -316 c75 -22 162 -109 184 -184 9 -30 16 -69 16 -87 l0 -33 -1008 0 c-965 0 -1012 -1 -1084 -19 -227 -58 -391 -222 -449 -449 -18 -72 -19 -123 -19 -1404 l0 -1328 -33 0 c-73 0 -138 29 -198 89 -97 97 -89 -51 -89 1671 0 1722 -8 1574 89 1671 42 42 71 62 107 73 42 13 209 15 1240 15 1060 1 1196 -1 1244 -15z m640 -640 c41 -12 67 -29 111 -73 97 -97 89 51 89 -1671 0 -1722 8 -1574 -89 -1671 -96 -96 10 -89 -1351 -89 -1361 0 -1255 -7 -1351 89 -97 97 -89 -51 -89 1671 0 1722 -8 1574 89 1671 42 42 71 62 107 73 42 13 209 15 1240 15 1060 1 1196 -1 1244 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bab0cdbdcf48d3dd34229d20608cc73c.svg";
export { ForwardRef as ReactComponent };